'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { MantineProvider } from '@mantine/core';
import { SessionProvider } from 'next-auth/react';
import { theme } from '@/theme';
import type { ReactNode } from 'react';
import type { Session } from 'next-auth';
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@/assets/styles/global.scss';

const queryClient = new QueryClient();

export default function Providers({
	children,
	session,
}: {
	children: ReactNode;
	session: Session | null;
}) {
	return (
		<SessionProvider session={session} refetchOnWindowFocus={false}>
			<QueryClientProvider client={queryClient}>
				<MantineProvider theme={theme}>{children}</MantineProvider>
			</QueryClientProvider>
		</SessionProvider>
	);
}
